import "../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import WsStateBanner from "./WsStateBanner.vue.es.js";
import xss from "xss";
import { useI18n } from "@odin/services";
import { defineComponent, computed, watchEffect, openBlock, createBlock, createCommentVNode } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
import { ref } from "../../node_modules/.pnpm/@vue_reactivity@3.5.13/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.es.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WsCartItemInfoBox",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const { t } = useI18n();
    const $t = (translationKey, variables) => {
      return xss(t(translationKey, variables));
    };
    const title = ref("");
    const text = ref("");
    const customDisplayCondition = ref(true);
    const shouldDisplay = computed(
      () => customDisplayCondition.value && !!title.value && !!text.value
    );
    function fillOutBMPostfixMigrationData() {
      title.value = $t("uikit:cart_item.notices.business_mail.license_count_increase.title");
      text.value = $t(
        "uikit:cart_item.notices.business_mail.license_count_increase.text",
        { count: props.item.properties.minimumNumberOfLicenses }
      );
      watchEffect(() => {
        customDisplayCondition.value = !props.item.properties.hasEnoughNumberOfLicenses;
      });
    }
    function fillOutFreeTrialBMData() {
      title.value = $t("uikit:cart_item.notices.business_mail.free_trial.title");
      text.value = $t("uikit:cart_item.notices.business_mail.free_trial.text");
    }
    function fillOutFreeTrialBMPostfixMigrationData() {
      title.value = $t("uikit:cart_item.notices.business_mail.free_trial_postfix.title");
      text.value = $t(
        "uikit:cart_item.notices.business_mail.free_trial_postfix.text",
        { count: props.item.properties.minimumNumberOfLicenses }
      );
    }
    function fillOutBMMinimumNumberOfPremiumLicensesData() {
      title.value = $t(
        "uikit:cart_item.notices.business_mail.free_trial_premium_licenses_notice.title",
        { count: props.item.properties.minimumNumberOfLicenses }
      );
      text.value = $t(
        "uikit:cart_item.notices.business_mail.free_trial_premium_licenses_notice.text",
        { count: props.item.properties.minimumNumberOfLicenses }
      );
    }
    watchEffect(() => {
      var _a, _b, _c, _d;
      const { item } = props;
      if (!item) {
        return;
      }
      if (item.code === "business-mail") {
        if ((_a = item.properties) == null ? void 0 : _a.freeTrial) {
          if ((_b = item.properties) == null ? void 0 : _b.minimumNumberOfLicenses) {
            fillOutFreeTrialBMPostfixMigrationData();
          } else {
            fillOutFreeTrialBMData();
          }
        } else if ((_c = item.properties) == null ? void 0 : _c.minimumNumberOfLicenses) {
          fillOutBMPostfixMigrationData();
        }
      }
      if (item.code === "business_mail_premium" && ((_d = item.properties) == null ? void 0 : _d.minimumNumberOfLicenses)) {
        fillOutBMMinimumNumberOfPremiumLicensesData();
      }
    });
    return (_ctx, _cache) => {
      return shouldDisplay.value ? (openBlock(), createBlock(WsStateBanner, {
        key: 0,
        class: "cart-item-info-box",
        title: title.value,
        text: text.value,
        icon: ""
      }, null, 8, ["title", "text"])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=WsCartItemInfoBox.vue.es2.js.map
